import { Config } from 'types'
import { getLocale, getShopId, queryClient, useApiQuery, useAuthentication } from 'utils'
import { planQuery } from './plan.api'

export const useConfig = () => {

    //hooks:
    const { isLoggedIn, logout } = useAuthentication()
    const shopId = getShopId()

    //values:
    const getBasicConfig = !isLoggedIn || !shopId
    const cacheKey = ['config', getBasicConfig ? null : shopId]

    return useApiQuery<Config>({
        query: getBasicConfig ? `
            query getConfig{
                getConfig{
                    locale
                }
            }
        ` : `
            query getConfig(
                $id: String
            ){
                getConfig(
                    id: $id
                ){

                    locale
                    isMigratedToMRML
                    features
                    maxApp

                    plan{
                        ${planQuery}
                    }

                    settings{
                        timezone
                    }

                }
            }
        `,
        variables: getBasicConfig ? undefined : {
            id: shopId
        },
        cacheKey,
        noAuth: getBasicConfig,
        onSuccess: json => {
            let config: Config = getBasicConfig ? {
                locale: json.data.getConfig.locale,
                features: [],
                isMigratedToMRML: true,
                maxApp: 0,
                plan: null,
                settings: {
                    timezone: 'UTC'
                }
            } : json.data.getConfig
            const locale = getLocale()
            if(getBasicConfig && locale){
                config = {
                    ...config, // for unauthenticated pages
                    locale
                }
            }
            return config
        },
        onError: () => {
            queryClient.removeQueries(cacheKey)
            if(isLoggedIn){
                logout()
            }
        }
    })
}
